import React from 'react';
import StoryViewer from './StoryViewer';
import type { UserStory } from '../types';

interface NewsViewerPageProps {
  stories: UserStory[];
  startIndex: number;
  onClose: () => void;
  onViewProfile: (user: any) => void;
  currentUserId?: string;
  onDeleteItem?: (ownerId: string, itemId: string) => Promise<void>;
  onReplyToNews?: (ownerId: string, item: any, text: string) => Promise<void>;
}

const NewsViewerPage: React.FC<NewsViewerPageProps> = ({ stories, startIndex, onClose, onViewProfile, currentUserId, onDeleteItem, onReplyToNews }) => {
  return (
    <div className="h-screen w-screen bg-app-backdrop text-white overflow-hidden">
      <StoryViewer
        stories={stories}
        startIndex={startIndex}
        onClose={onClose}
        onViewProfile={onViewProfile}
        currentUserId={currentUserId}
        onDeleteItem={onDeleteItem}
        onReplyToNews={onReplyToNews}
      />
    </div>
  );
};

export default NewsViewerPage;
